import { createActionConst } from '../../../utils/action.utils';

const PASSWORDS_PAGE_NAMESPACE = 'PASSWORDS_PAGE';

export const INITIAL_PASSWORDS_PAGE = createActionConst(PASSWORDS_PAGE_NAMESPACE, 'INITIAL_PASSWORDS_PAGE');
